import { createFileRoute } from "@tanstack/react-router";
import { useProject, useProjectEvents } from "@/api/projects";
import { Page } from "@/components/shell/PageHeader";
import { ActivityFeed } from "@/components/activity/ActivityFeed";

export const Route = createFileRoute("/_app/projects/$projectId/activity")({
  validateSearch: (s: Record<string, unknown>): { highlight?: string } => (typeof s.highlight === "string" ? { highlight: s.highlight } : {}),
  component: ActivityPage,
});

function ActivityPage() {
  const { projectId } = Route.useParams();
  const { highlight } = Route.useSearch();
  const project = useProject(projectId);
  const events = useProjectEvents(project.data?.id ?? "");
  if (!project.data) return null;
  return (
    <Page>
      <ActivityFeed events={events.data?.events ?? []} highlight={highlight} />
    </Page>
  );
}
